const state = {
    id: 0,
    start_date: "",
    end_date: "",
    name: "",
    description: "",
    is_active: false,
};

const mutations = {
    periode_init(state, payload) {
        state.id = payload.id;
        state.start_date = payload.start_date;
        state.end_date = payload.end_date;
        state.name = payload.name;
        state.description = payload.description;
        state.is_active = payload.is_active;
    },
};

export default { state, mutations };



// WEBPACK FOOTER //
// ./src/modules/ambis_meter/stores/ambis_meter.js